class FooterAccordion extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.els?.heading?.element?.addEventListener(
      'click',
      this.toggleAccordion.bind(this),
    )

    this.accordions = this.externalEls?.accordion?.elements
  }

  toggleAccordion () {
    this.ariaExpanded = this.ariaExpanded === 'true' ? 'false' : 'true'

    this.closeExternalAccordions()
  }

  closeExternalAccordions () {
    if (!this.accordions) return

    this.accordions.forEach(accordion => {
      if (accordion !== this) {
        accordion.ariaExpanded = false
      }
    })
  }

  set accordions (els) {
    this._accordions = els
  }

  get accordions () {
    return this._accordions
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion)
}
